const theme = {
 initialColorMode: "light",
 colors: {
  text: "text-black",
  background: "#F1F1F1",
  fill: "black",
  primary: "#1408e6",
  inverseText: "blue",
  highlight: "white",
  stroke: "black",
  gray: "#D1D1D1",
  light_gray: "#e5e7eb",
  light_gray2: "#f8f8f8",
  body_gray: "#f1f1f1",
  bgGray: "bg-white",
  sky: "#d0e2ff",
  modes: {
   dark: {
    text: "white",
    background: "#151212;",
    headerBg: "#f1f1f1",
    primary: "#8fceff",
    inverseText: "green",
    highlight: "black",
    fill: "white",
    stroke: "white",
    gray: "#232323",
    light_gray: "#232323",
    light_gray2: "#232323",
    bgGray: "bg-gray",
    sky: "#232323",
    body_gray: "black",
   },
  },
 },
}

export default theme
